module.exports = __webpack_public_path__ + "media/assets/community/filter-logo-62092f992a7c12c2a53d8781f29c054f71d03a4bf6c8752c31910aa6b5e38f36.png";